// extracted by mini-css-extract-plugin
export var cardHeader = "_gu-1";
export var contentCard = "_gu-0";
export var headerActions = "_gu-3";
export var reorderHandle = "_gu-5";
export var titleArea = "_gu-2";
export var titleAreaWithHandle = "_gu-4";